import { useStore } from '../../store/useStore';


const pictogramOptions = [
    {
        'value':'vinarstvi_sklep',
        "icon":"vinar_sklep.png",
        "label":"Vinařství / vinný sklep",
    },
    {
        'value':'ubytovani',
        'icon': 'ubytovani.png',
        'label': "Ubytování",
    },
    {
        'value':'restaurace',
        'icon': 'restaurace.png',
        'label':"Restaurace",
    },
    {
        'value':'sluzby',
        'icon': 'storefront_outline.png',
        'label': "Služby",
    },
    {
        'value':'turisticky_cil',
        'icon': 'turist_cil.png',
        'label': "Turistický cíl",
    },
    {
        'value':'infocentrum',
        'icon': 'info.png',
        'label': "Infocentrum",
    },
    {
        'value':'pro_deti',
        'icon': 'pro_deti.png',
        'label': "Pro děti",
    },
    {
        'value':'koupaliste_lazne',
        'icon': 'koupaliste_lazne.png',
        'label': "Koupaliště / Lázně",
    },
    {
        'value':'hrad_zamek',
        'icon': 'hrad_zamek.png',
        'label': "Hrad / Zámek",
    },
    {
        'value':'kavarna_cukrarna',
        'icon': 'kavarna_cukrarna.png',
        'label': "Kavárna / Cukrárna",
    },
    {
        'value':'muzeum_galerie',
        'icon': 'muzeum.png',
        'label': "Muzeum / Galerie",
    },
    {
        'value':'rozhledna_vyhlidka',
        'icon': 'rozhledna.png',
        'label': "Rozhledna / vyhlídka",
    },
];

const iconOptions = [
    {   
        'value':'pristupne',
        'icon': 'door_open.png',
        'label': "Přístupné",
    },
    {
        'value':'kultura',
        'icon': 'drama_masks.png',
        'label': "Kultura",
    },
    {
        'value':'email',
        'icon': 'email.png',
        'label': "E-mail",
    },
    {
        'value':'facebook',
        'icon': 'facebook.png',
        'label': "Facebook",
    },
    {
        'value':'instagram',
        'icon': 'instagram.png',
        'label': "Instagram",
    },
    {
        'value':'web',
        'icon': 'web.png',
        'label': "Web",
    },
    {
        'value':'phone',
        'icon': 'phone.png',
        'label': "Telefon",
    },
    {
        'value':'youtube',
        'icon': 'youtube.png',
        'label': "Youtube",
    },
    {
        'value':'pokracovat',
        'icon': 'pokracovat.png',
        // 'dataUri': 'data:image/png;base64,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',
        'label': "Pokračovat",
    }
];



const pictogramsByValue = pictogramOptions.reduce((acc, cur) => {
    acc[cur.value] = cur;
    return acc;
}, {});
// console.log("pictograsByValue", pictogramsByValue);


const iconsByValue = iconOptions.reduce((acc, cur) => {
    acc[cur.value] = cur;
    return acc;
}, {});

const PictogramLink = ({value, type="pictogram"}) => {
    const store = useStore();
    const urlBase = store.getBaseURL();

    const dir = type === "pictogram" ? "piktogramy" : "ikony";
    // console.log("PictogramLink", value, type, dir);
    const pictogram = type==="pictogram" ? pictogramsByValue[value] : iconsByValue[value];
    if (!pictogram) {
        return null;
    }
    if (pictogram.dataUri) {
        return pictogram.dataUri;
    }
    const link = `${urlBase}/images/podklady/gray/${dir}/${pictogram.icon}`;
    return link;
}

const PictogramLabel = ({value, type="pictogram"}) => {
    return type === "pictogram" ? pictogramsByValue[value].label : iconsByValue[value].label;
}

const PictogramIcon = ({value, type="pictogram", asMask=true, color}) => {
    // console.log("PictogramIcon", value, type);
    const link = PictogramLink({value, type});
    const label = PictogramLabel({value, type});

    let maskStyle = {
        maskImage: `url(${link})`,
        WebkitMaskImage: `url(${link})`,
    };

    if (color) {
        maskStyle.backgroundColor = color;
    }

    if (asMask) {
        return <div className={"picto-icon picto-type-"+type} style={maskStyle} title={label}></div>;
    }


    return <img className={"nakip_"+type} src={link} alt={label} />;


    // return <div className={"nakip_"+type} style={style} title={label} />;
}


export { pictogramOptions, iconOptions, PictogramLink, PictogramLabel, PictogramIcon };

    
